var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 99,
    viewBox: "0 0 108 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_455_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6636 50.7969C41.3886 49.392 53.3265 59.0137 53.3265 72.2872C53.3265 85.5608 41.3886 97.4596 26.6636 98.8637C11.9379 100.268 0 90.6471 0 77.3733C0 64.1 11.9381 52.2014 26.6636 50.7969ZM33.2762 53.1656C45.5784 54.4736 53.6202 64.8056 51.2378 76.243C48.8573 87.6804 36.9532 95.892 24.6518 94.5838C12.3494 93.2756 4.30733 82.9441 6.68952 71.5065C9.07073 60.0691 20.9741 51.8581 33.2762 53.1656Z",
    fill: "#8C033E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.3372 66.1083C66.6115 67.5131 54.6738 57.8914 54.6738 44.6179C54.6738 31.3446 66.6115 19.4458 81.3372 18.0414C96.0621 16.6368 108 26.2583 108 39.5318C108 52.8054 96.0621 64.7039 81.3372 66.1083ZM74.724 63.7395C62.4216 62.4315 54.3801 52.0993 56.7615 40.6621C59.143 29.2247 71.0468 21.0131 83.3485 22.3213C95.6506 23.6295 103.693 33.962 101.311 45.3989C98.9293 56.8363 87.0259 65.0477 74.724 63.7395Z",
    fill: "#8C033E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7163 34.2107C35.206 34.4901 44.7345 43.0843 51.9851 54.5656C45.0249 41.3672 34.9421 29.8184 20.5368 26.7113C-2.31539 21.7808 -1.34474 42.5594 12.7058 42.5594C18.2342 42.5594 22.7163 38.8279 22.7163 34.2254V34.2104V34.2107Z",
    fill: "#8C033E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.2837 82.6935C73.0384 82.3943 64.5067 73.8078 57.2646 62.3398C64.1762 75.4458 73.5691 87.2191 87.8975 90.2568C110.16 94.9743 109.349 74.3458 95.2945 74.3458C89.7661 74.3458 85.284 78.0773 85.284 82.68V82.6935H85.2837Z",
    fill: "#8C033E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.4833 0.0107374C79.1208 -0.268752 74.7234 4.91832 74.1904 14.3616C80.7813 11.7515 85.4331 6.83408 88.4833 0.0107374Z",
    fill: "#8C033E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_455_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 99,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.c4b24ad0f3b4067cd13c00cf257b5aa9.svg";
export { ForwardRef as ReactComponent };